<template>
    <div class="wrapper">
        <b-spinner variant="success" class="spinStyle" v-show="showSpin" label="Text Centered"></b-spinner>
        <div>
            <div class="register-content">
                <b-row class="justify-content-lg-center register-info">
                    <b-col lg="8" class="register-wrap">
                        <b-card header="会员申请">
                            <b-form class="registerForm">
                                <b-form-group label="申请日期：" label-cols-lg="3" label-align-lg="right" label-size="sm">
                                    <b-form-input size="sm"  readonly placeholder="申请日期"
                                        v-model="memberInfoForm.memberCreateTime" class="custom-input"></b-form-input>
                                </b-form-group>
                                <b-form-group label="申请人：" label-cols-lg="3" label-align-lg="right" label-size="sm">
                                    <b-form-input autocomplete="off" size="sm" @blur="memberNameBlur(memberInfoForm.memberName)"
                                        placeholder="请输入申请人"  v-model="memberInfoForm.memberName" class="custom-input"></b-form-input>
                                </b-form-group>
                                <b-form-group label="手机号码：" label-cols-lg="3" label-align-lg="right" label-size="sm">
                                    <b-form-input autocomplete="off" size="sm" placeholder="请输入手机号码" v-model="memberInfoForm.memberPhone"
                                        @blur="memberPhoneBlur(memberInfoForm.memberPhone)" class="custom-input"></b-form-input>
                                </b-form-group>
                                <b-form-group label="客户类型：" label-cols-lg="3" label-align-lg="right" label-size="sm">
                                    <Select v-model="memberInfoForm.accountType" clearable
                                        filterable placeholder="请点击客户类型">
                                        <Option v-for="item in accountTypeList" :value="item"
                                            :key="item">{{item}}</Option>
                                    </Select>
                                </b-form-group>
                                <b-form-group label="验证码：" v-if="showSmsCode" label-cols-lg="3" label-align-lg="right"
                                    label-size="sm">
                                    <b-input-group>
                                        <b-form-input autocomplete="off" size="sm" placeholder="请输入验证码" v-model="memberInfoForm.smsCode"
                                            class="custom-input">
                                        </b-form-input >
                                        <b-input-group-append>
                                            <b-button size="sm" :disabled="timer !== 60" @click="getCode()"
                                                class="btn-code">{{smsButtonText}}</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                                <b-form-group  label="生产种类：" label-cols-lg="3" label-align-lg="right" label-size="sm" class="productType">
                                  <b-form-input v-if="memberInfoForm.selectMainCategoryStr" v-model="memberInfoForm.selectMainCategoryStr"></b-form-input>
                                  <div class="row" style="display: flex; flex-wrap: wrap; ">
                                    
                                    <div v-for="(mainCate, index) in memberInfoForm.mainCateList"  :key="index"  class="col-lg-4">
                                      <b-form-checkbox 
                                        v-model="memberInfoForm.memberProductionTypeArray"
                                        :value="mainCate.mainCategoryName" 
                                        @click="onClickMainCate(mainCate)">
                                        {{ mainCate.mainCategoryName }}
                                      </b-form-checkbox>
                                    </div>
                                  </div>
                                </b-form-group>
  
                                <!-- <b-form-group  label-cols-lg="3" label-align-lg="right" label-size="sm" />                         -->
                                <b-form-group style="margin-top: 6%;" label="客户经理：" label-cols-lg="3" label-align-lg="right" label-size="sm">
                                    <Select v-model="memberInfoForm.memberRelateCustomerManagerUuid" clearable
                                        filterable placeholder="请点击选择经理" >
                                        <Option v-for="item in subCateManagerList" :value="item.value"
                                            :key="item.value">{{item.label}}</Option>
                                    </Select>
                                </b-form-group>
                               
                                <b-form-group label="种植面积："  label-cols-lg="3" label-align-lg="right"
                                    label-size="sm">
                                    <b-input-group>
                                             <!-- 温室面积 -->
                                             <b-form-input size="sm" class="custom-input"  @blur="checkPositiveNumber(memberInfoForm.userExternalCustomerGreenhouseArea)" type="number" placeholder="请输入种植面积" v-model="memberInfoForm.userExternalCustomerGreenhouseArea">
                                            </b-form-input>
                                        <b-input-group-append>
                                             <!-- 温室面积单位 -->
                                           <p style="margin: 0 10px">单位：</p>
                                            <b-form-select style="width: 120px"
                                              v-model="memberInfoForm.unit"
                                              class="custom-select"
                                              size="sm">
                                              <option value="">请选择</option>
                                              <option 
                                                :value="item.value"
                                                v-for="item in unitList"
                                                :key="item.value">
                                                {{item.label}}
                                              </option>
                                            </b-form-select>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>

                              <!-- 省市县选择 -->
                             <b-form-group label="省：" label-cols-lg="3" label-align-lg="right"
                                              label-size="sm">
                                  <b-input-group>

                                    <b-form-select 
                                      v-model="memberInfoForm.userExternalCustomerProvinceUuid"
                                      size="sm"
                                      @change="onProviceSelectChange"
                                      class="custom-select" style="width: 30%;">
                                      <option 
                                        :value="item.regionUuid"
                                        v-for="item in provinceList"
                                        :key="item.regionUuid">
                                        {{item.regionName}}
                                      </option>
                                    </b-form-select>

                                    <b-input-group-append style="width: 35%;" >
                                      <span style="margin: 0 8px;">市：</span>
                                      <b-form-select 
                                        v-model="memberInfoForm.userExternalCustomerCityUuid"
                                        size="sm"
                                        class="custom-select"
                                        @change="onCitySelectChange">
                                        <option 
                                          :value="item.regionUuid"
                                          v-for="item in cityList"
                                          :key="item.regionUuid">
                                          {{item.regionName}}
                                        </option>
                                      </b-form-select>
                                    </b-input-group-append>

                                    <b-input-group-append style="width: 35%;">
                                      <span style="margin: 0 8px;">县：</span>
                                      <b-form-select 
                                        v-model="memberInfoForm.userExternalCustomerDistUuid"
                                        size="sm"
                                        class="custom-select">
                                        <option 
                                          :value="item.regionUuid"
                                          v-for="item in distList"
                                          :key="item.regionUuid">
                                          {{item.regionName}}
                                        </option>
                                      </b-form-select>
                                    </b-input-group-append>
                                    
                                  </b-input-group>
                                </b-form-group>
                               <b-form-group label="详细地址：" label-cols-lg="3" label-align-lg="right" label-size="sm">
                                        <b-form-input v-model="memberInfoForm.userExternalCustomerFullAddress" size="sm" placeholder="必填"></b-form-input>
                               </b-form-group>



                                <div class="statement">
                                    <b-form-checkbox v-model="statementChecked">
                                        <span>我已阅读并同意</span>
                                      <!--  <a href="#" @click="showPrivace = true">《隐私协议》</a>
                                        <a href="#" @click="showUserDeal = true">《用户协议》</a>
                                        <a href="#" @click="showRule = true">《交易细则》</a> -->
                                        <a href="#" @click="showContractRule = true">《种苗定购协议》</a>、
                                        <a href="#" @click="showPrivace = true">《隐私政策》</a>
                                    </b-form-checkbox>
                                </div>

                                <div class="btn-wrap d-flex" v-if="showApplyBtn">
                                    <b-button ref="uCode" variant="primary" :disabled="showSpin"
                                        @click="onSavePersonInfo" class="new-btn register-btn">
                                        <span>提交申请</span>
                                    </b-button>
                                </div>
                                <div class="login">
                                    <b-link :to="{name:'MemberLogin'}" class="login_a">
                                        直接登录
                                    </b-link>
                                </div>
                            </b-form>
                        </b-card>
                    </b-col>
                </b-row>

            </div>
            <div class="home-footer">
                <p>版权所有 © 缤纷园艺有限公司 <a href="https://beian.miit.gov.cn" target="_blank">粤ICP备05082648号</a></p>
                <p>建议使用IE10.0或以上版本浏览本网站</p>
            </div>
        </div>

        <b-modal v-model="showRule" title="交易细则" hide-footer size="lg" scrollable @close="showRule = false">
            <div>
                <p>网上订购条款细则</p>
                <p>一般条款：</p>
                <p>1.本网站/应用程序只供缤纷客户订购产品使用。</p>
                <p>2.顾客有责任提供真实准确的最新资料以便本网站/应用程序的登记手续。</p>
                <p>3.缤纷有绝对的知情权，可基于任何理由拒绝任何人成为会员，并且可终止任何客户登记，对于违反缤纷细则操作的客户将列入黑名单。</p>
                <p>4.本网站全天24小时均可下单定购。</p>
                <p>5.本网站上购物只接受缤纷唯一的网上官方途径交易，拒绝一切线下形式的交易。目前支持微信、支付宝、银行卡充值。交易以缤纷账号收到交易款为准。</p>
                <p>6.顾客需要保管好其账号信息，如记录有任何变更，经其授权使用造成的损失，顾客须自行负责。</p>
                <p>7.种苗是鲜活产品，会有季节或者品种差异，网上图片仅供参考。</p>
                <p>8.所有产品的大小规格均以本网站描述为准，仅供参考。</p>
                <p>9.由于缺货、替换
                    、特别优惠、价格浮动等不定期变更等因素，网上显示的账单可能会与最终账单不一致，缤纷保留权利，可在网上对订单做出调整，相关调整会最终送货或者取货时向顾客提供最终账单列明。</p>
                <p>10.若遇到系统问题，缤纷保留追讨差价的权利。</p>
                <p>11.缤纷将根据隐私政策及声明使用如下资料包括（但不止于）姓名、通讯录、电话地址、微信账号、以及为提供本公司各项服务所需的其他资料。有关隐私政策及声明，请浏览本网站内的隐私权限政策。
                </p>
                <p>12.如本规则中的任何条文在某司法管辖区法律无效、不合法或不可执行，将不影响该条文在其他司法管辖区的有效性、合法性或可执行性。</p>
                <p>13.以上有关各项条款及细则如有任何更改，恕不另行通知，如有任何争议，缤纷园艺有限公司保留最终决定权。</p>
                <p>送货及自提货品</p>
                <p>送货</p>
                <p>1.所有种苗的送货范围都由配送站而定，送货时间和收费在顾客选定商品、结账时列出来供选择。</p>
                <p>2.顾客的收货地址如有任何更改，必须于送货日期之前48小时前通知客户经理，否则不接受任何取消或变更，定金不可退。</p>
                <p>自取貨品</p>
                <p>1.顾客只限于约定的时间地点内取货。</p>
                <p>2.顾客于指定取货日到指定地点取货，需要出示本公司发出的取货单。</p>
                <p>3.顾客必须于选定的取货日期内取货，如有逾期未取，将作为自动放弃订单，恕不退回已付款项。</p>
                <p>退款退货</p>
                <p>1.常规种苗网产品不支持退货，除了质量问题可以当场验收时提出异议，不接受退货换货。</p>
                <p>2.个别产品所在「产品介绍」处标明的可以退换时接受退换。</p>
                <p>3.任何退款将首先退还至顾客的会员账户余额内，顾客需要进行提现操作至顾客的充值卡账户內。</p>
                <p>4.如有任何争议，缤纷园艺有限公司保留最终决定权。</p>
            </div>
        </b-modal>

        <b-modal v-model="showUserDeal" title="用户协议" hide-footer size="lg" scrollable @close="showUserDeal = false">
            <div>
                <p>重要提示：</p>
                <p>请您仔细阅读以下条款，并确认您已完全理解本协议之规定，尤其是免除及限制责任的条款、法律适用及争议解决条款。若您对本协议任何条款有异议，请停止注册或使用本网站，包括手机、电脑等移动设备客户端，下同）所提供的全部服务。
                </p>
                <p>勾选本协议前选项框，将视为您签署了本协议，表明您自愿接受本协议全部条款的约束。</p>
                <p>缤纷种苗网是缤纷园艺有限公司下属网站，以下简称种苗网。种苗网有权利对本协议进行修改，协议修改后，种苗网将通过在相关页面公告或发送通知等方式公布修改的内容，修改后的协议一经公布即有效的代替原协议。
                </p>
                <p>如果您不同意本协议的修改，请立即停止访问或使用本网站或取消已经获得的服务；如果您选择继续访问或使用本网站，则视为您已接受本协议的修改。</p>
                <p>签署的本协议所列明的条款，并不能完全涵盖您与种苗网之间所有的权利和义务。因此，种苗网将不定期公布的其他声明、规则等均视为本协议之补充协议，如本协议与种苗网平台其它协议条款不一致，以其它协议条款内容为准。
                </p>
                <p>1、种苗网是缤纷种苗和缤纷客户进行交易的唯一途径。</p>
                <p>2、种苗网实行会员制，申请会员后本人凭账号及密码上网交易。</p>
                <p>3、用户提供的个人信息不真实、不准确；种苗网有权终止用户使用平台服务。</p>
                <p>4、会员账号只限于本人使用。账户不得转让，借人使用，违者产生的一切不良后果将由会员本人承担，种苗网会收回会员号，并终止会籍。</p>
                <p>5、密码是会员的重要个人资料，需认真设置、管理与使用，凡使用本网账户和密码办理的业务，均视为会员本人亲自办理。</p>
                <p>6、用户不得利用种苗网散布淫秽、色情、赌博内容。</p>
                <p>7、用户在网上交易与操作，须遵守缤纷种苗网的《交易规则》、《用户协议》及随时修改的使用条款，违者将终止会籍并拉入黑名单，不得再次申请。不做任何补偿。</p>
                <p>8、本《用户协议》解释权属昆明缤纷园艺有限公司。</p>
            </div>
        </b-modal>

        <b-modal v-model="showPrivace" title="隐私政策" hide-footer size="xl" @close="showPrivace = false">
            <iframe
                src="https://oss.brighten-floriplant.cn/privacy2.html"
                width="100%"
                height="600"
                frameborder="0"
                style="border: none;"
            ></iframe>
        </b-modal>
		
		
		<b-modal v-model="showContractRule" title="种苗定购协议" hide-footer size="xl"
					@close="showContractRule = false">
					<iframe
                        src="https://oss.brighten-floriplant.cn/contract.html"
                        width="100%"
                        height="600"
                        frameborder="0"
                        style="border: none;"
                    ></iframe>
				</b-modal>
		
        <b-modal v-model="showReminder" title="温馨提示" hide-footer size="lg" @close="showReminder= false">
            <b-row align-v="center">
                <b-col lg="12">
                    <div>
                        <p style="text-indent:2em;">
                            您的会员申请请求已发送成功，已移交客户经理审批，客户经理将在30分钟内回复。若30分钟内客户经理没有回复，您将收到一条含账号密码的短信，请您留意！</p>
                    </div>
                </b-col>
            </b-row>
            <div class="reminder-footer">
                <div style="width: 200px;height: 30px; background-color: #ccc; color: #EC4040; font-size: 18px; padding:0 10px;">
                        倒计时：{{min}} : {{sec}}
                </div>
                <b-button size="sm" variant="success" @click="goToIndex()">
                    返回首页继续浏览
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import api from '@/api/api';
    import search from '@/libs/search';
    export default {
        name: 'MemberRegister',
        data() {
            return {
                loginUuid: '',
                timeSecond: 0,
                showRegisterTips: false,
                showSmsCode: true,
                showSpin: false,
                showApplyBtn: true,
                timer: 60,
                smsTimer: null,
                smsButtonText: "获取验证码",
                statementChecked: false,
                memberInfoForm: {
                    memberCreateTime: "",
                    memberName: "",
                    memberPhone: "",
                    memberProductionType: '',
                    memberProductionTypeArray: [],
                    smsCode: "",
                    mainCateList: [],
                    codeType: "register",
                    memberRelateCustomerManagerUuid: '',
                    selectMainCategoryStr: '',
                    unit: '',
                    userExternalCustomerGreenhouseArea: 0,
                    accountType: '',
                    userExternalCustomerProvinceUuid: '3409',
                    userExternalCustomerCityUuid: '3410',
                    userExternalCustomerDistUuid: '3411',
                    userExternalCustomerFullAddress: ''
                },
                accountTypeList: [
                    "种苗种植户",
                    "花店",
                    "家庭园艺爱好者",
                    "电商",
                    "批发商",
                    "其他"],
                unitList: [
				{
					value: '平方米',
					label: '平方米'
				},
				{
					value: '亩',
					label: '亩'
				}
			],
                subCateManagerList: [],
                showPrivace: false,
                showUserDeal: false,
                showRule: false,
				showContractRule: false,
                showReminder: false,
                min: '',
                sec: '',
                provinceList: [],  // 省份列表
                cityList: [],      // 城市列表
                distList: []       // 区县列表
            };
        },
        mounted() {
            this.init();
            this.getAllRegionList();
        },
        beforeDestroy() {
            clearInterval(this.smsTimer);
            this.smsTimer = null;
        },
        methods: {
            // 获取所有区域列表，并根据选中的省市更新城市和区列表
            getAllRegionList() {
                this.cityList = [];
                this.distList = [];
                
                api.webGetAllRegion().then(res => {
                    if (res.code === 0) {
                        this.regionList = res.data.allRegions;
                        this.provinceList = this.regionList.filter(e => e.regionType === 1);
                        
                        let orderList = ['云南', '广东', '山东', '辽宁', '江苏', '福建', '上海', '河南', '新疆', '四川', '北京', '浙江', '湖北', '海南', '安徽', '河北', '黑龙江', '陕西', '天津', '贵州', '甘肃', '吉林', '湖南', '山西', '宁夏', '江西', '重庆', '广西', '西藏', '内蒙古', '全国', '香港']


                        const getIndex = provin => {
                            let index = orderList.findIndex(element => element === provin.regionName);
                            index = index > -1 ? index : 999;
                            return index;
                        };
                        //排序
                        this.provinceList.sort((a, b) => getIndex(a) - getIndex(b));

                        if (this.memberInfoForm.userExternalCustomerProvinceUuid) {
                            this.cityList = this.regionList.filter(e => e.regionParentUuid === this.memberInfoForm.userExternalCustomerProvinceUuid);
                        }
                        if (this.memberInfoForm.userExternalCustomerCityUuid) {
                            this.distList = this.regionList.filter(e => e.regionParentUuid === this.memberInfoForm.userExternalCustomerCityUuid);
                        }

                    }
                });
            },

            // 处理省选择变化，更新城市和区列表
            onProviceSelectChange(value) {
                this.cityList = [];
                this.distList = [];
                
                if (value) {
                    this.cityList = this.regionList.filter(e => e.regionParentUuid === value);
                }
                this.memberInfoForm.userExternalCustomerProvinceUuid = value;
            },

            // 处理城市选择变化，更新区列表
            onCitySelectChange(value) {
                this.distList = [];
                
                if (value) {
                    this.distList = this.regionList.filter(e => e.regionParentUuid === value);
                }
                this.memberInfoForm.userExternalCustomerCityUuid = value;
            },

            // 处理区选择变化，更新区 UUID
            onDistSelectChange(value) {
                this.memberInfoForm.userExternalCustomerDistUuid = value;
            },

            init() {
                let planTime = this.$cookies.get('planTime');
                if (!planTime) {
                    //未提交过申请且未登录
                    this.initData();
                } else {
                    this.countdown(planTime);
                    //提交过申请
                    let curDateTamp = new Date().getTime();
                    if (planTime > curDateTamp) {
                        if (this.$cookies.get('userUuid')) {
                            //判断是否审核通过及未通过
                            api.checkUserStatus({
                                "userUuid": this.$cookies.get('userUuid')
                            }).then(res => {
                                if (res.code === 0 && res.data == 1) {
                                    this.resetStatus();
                                } else if (res.code === 0 && res.data == 2) {
                                    this.showTips();
                                }
                            });
                        } else {
                            this.initData();
                        }
                    } else {
                        this.resetStatus();
                    }
                }
            },
            showTips() {
                //30分钟内
                this.showSmsCode = false;
                this.showSubmitBtn = false;
                this.showSpin = false;
                this.showApplyBtn = false;
                this.showReminder = true;
                this.initData();
                this.getMemberDetailInfo();
            },
            resetStatus() {
                //30分钟后
                this.$cookies.remove('planTime');
                this.$cookies.remove('userUuid');
                this.initData();
            },
            initData() {
                this.getCurDate();
                this.webGetMainCategoryList();
                this.getCateManagerDetailRelationList();
            },
            goToIndex() {
                this.$router.push({
                    name: 'Home'
                });
            },
            webGetMainCategoryList() {
                let tempSearch = search.getSearchParams({
                    closeAllConditions: true
                });
                api.webGetMainCategoryList(tempSearch).then(res => {
                    if (res.code === 0) {
                        this.memberInfoForm.mainCateList = res.data.records;
                    }
                });
            },
            getCode() {
                if (this.$refs.uCode.canGetCode) {
                    this.$bvModal.msgBoxOk("请先输入手机号码", {
                        title: '提示',
                        buttonSize: 'sm'
                    });
                    return;
                }
				var memPhone = (/^(13[0-9]|14[1579]|15[0-3,5-9]|16[6]|17[0123456789]|18[0-9]|19[0-9])\d{8}$/); //手机号码
				if (!memPhone.test(this.memberInfoForm.memberPhone)) {
				    this.$bvModal.msgBoxOk("手机号码不符合格式", {
				        title: '提示',
				        buttonSize: 'sm'
				    });
				    return;
				}
                this.showSpin = true;
                let data = {
                    codeType: 'register',
                    userPhone: this.memberInfoForm.memberPhone
                };
                api.externalCustomerGetSmsCode(data).then(res => {
                    this.showSpin = false;
                    if (res.code === 0) {
                        this.$bvModal.msgBoxOk("验证码已发送...", {
                            title: '提示',
                            buttonSize: 'sm'
                        });
                        this.smsTimer = setInterval(() => {
                            this.getSmsButtonText();
                        }, 1000);
                    }
                });
            },
            getSmsButtonText() {
                this.smsButtonText = this.timer + '秒后再试';
                this.timer -= 1;
                if (this.timer < 0) {
                    clearInterval(this.smsTimer);
                    this.smsTimer = null;
                    this.smsButtonText = "获取验证码";
                    this.timer = 60;
                }
            },
            // 手机格式检验
            memberPhoneBlur(val) {
                var memPhone = (/^(13[0-9]|14[1579]|15[0-3,5-9]|16[6]|17[0123456789]|18[0-9]|19[0-9])\d{8}$/); //手机号码
                if (!memPhone.test(val)) {
                    this.$bvModal.msgBoxOk("手机号码不符合格式", {
                        title: '提示',
                        buttonSize: 'sm'
                    });
                    return;
                }
            },
            // 申请人校验
            memberNameBlur(val) {
                if (val.length < 2 || val.length > 20) {
                    this.$bvModal.msgBoxOk("申请人请控制在2-10个字符内", {
                        title: '提示',
                        buttonSize: 'sm'
                    });
                    return;
                }
            },
            // 检验种植值是否为正数
            checkPositiveNumber(val) {
            if (val <= 0) {
                this.$bvModal.msgBoxOk("输入值必须大于 0", {
                    title: '提示',
                    buttonSize: 'sm'
                });
                this.memberInfoForm.userExternalCustomerGreenhouseArea=0
                return false;
            }
            return true; 
            },
            countdown(future){
                const msec = parseInt(future) - new Date().getTime();
                if (msec < 0) {
                    this.resetStatus();
                    return;
                }
                let min = parseInt(msec / 1000 / 60 % 60);
                let sec = parseInt(msec / 1000 % 60);
                this.min = min > 9 ? min : '0' + min;
                this.sec = sec > 9 ? sec : '0' + sec;
                const that = this;
                if (min >= 0 && sec >= 0) {
                    //倒计时结束关闭
                    if (min == 0 && sec == 0) {
                        this.resetStatus();
                        return;
                    }
                    setTimeout(function() {
                        that.countdown(future)
                    }, 1000)
                }
            },
            // 提交申请
            onSavePersonInfo() {
                this.updatePersonInfo();
            },
            // 校验提交申请
            updatePersonInfo() {
                if (this.memberInfoForm.memberName === '') {
                    this.$bvModal.msgBoxOk('请输入申请人');
                    return;
                }
                if (this.memberInfoForm.memberPhone === '') {
                    this.$bvModal.msgBoxOk('请输入手机号');
                    return;
                }
                if (this.memberInfoForm.smsCode === '') {
                    this.$bvModal.msgBoxOk('请输入验证码');
                    return;
                }
                if (this.memberInfoForm.memberProductionTypeArray.length == 0) {
                    this.$bvModal.msgBoxOk('请选择生产种类');
                    return;
                }
                if (this.memberInfoForm.memberName.length < 2 || this.memberInfoForm.memberName.length > 20) {
                    this.$bvModal.msgBoxOk('申请人请控制在2-10个字符内');
                    return;
                }
                var memPhone = (/^(13[0-9]|14[1579]|15[0-3,5-9]|16[6]|17[0123456789]|18[0-9]|19[0-9])\d{8}$/); //手机号码
                if (!memPhone.test(this.memberInfoForm.memberPhone)) {
                    this.$bvModal.msgBoxOk("手机号码不符合格式", {
                        title: '提示',
                        buttonSize: 'sm'
                    });
                    return;
                }
                if (this.memberInfoForm.accountType === '') {
                    this.$bvModal.msgBoxOk('请选择客户类型');
                    return;
                }
                if (this.memberInfoForm.userExternalCustomerGreenhouseArea===0||this.memberInfoForm.userExternalCustomerGreenhouseArea==undefined  ) {
                    this.$bvModal.msgBoxOk('请填写种植面积');
                    return;
                }
                if (this.memberInfoForm.unit === '') {
                    this.$bvModal.msgBoxOk('请选择面积单位');
                    return;
                }
                if (this.memberInfoForm.userExternalCustomerProvinceUuid === ''||this.memberInfoForm.userExternalCustomerProvinceUuid === '3409') {
                    this.$bvModal.msgBoxOk('请选择所在省');
                    return;
                }
                if (this.memberInfoForm.userExternalCustomerCityUuid === ''||this.memberInfoForm.userExternalCustomerCityUuid === '3410') {
                    this.$bvModal.msgBoxOk('请选择所在市');
                    return;
                }
                if (this.memberInfoForm.userExternalCustomerDistUuid === ''||this.memberInfoForm.userExternalCustomerDistUuid === '3411') {
                    this.$bvModal.msgBoxOk('请选择所在县');
                    return;
                }
                if (this.memberInfoForm.userExternalCustomerFullAddress === '') {
                    this.$bvModal.msgBoxOk('请输入详细地址');
                    return;
                }
             
                this.showSpin = true;
                this.memberInfoForm.memberProductionType = this.memberInfoForm.memberProductionTypeArray.join('|');
                api.externalCustomerUserRegisterByPhone(this.memberInfoForm).then(res => {
                    this.showSpin = false;
                    if (res.code === 0) {
                        this.timeSecond = res.data.seconds;
                        this.loginUuid = res.data.userUuid;
                        this.$cookies.set('userUuid', res.data.userUuid);
                        this.$cookies.set('planTime', res.data.planTime);
                        this.showSmsCode = false;
                        this.showSubmitBtn = false;
                        this.showReminder = true
                    }
                });
            },
            // 获取当前日期
            getCurDate() {
                let curDate = new Date();
                this.memberInfoForm.memberCreateTime = curDate.getFullYear() + "-" + (curDate.getMonth() + 1) + "-" +
                    curDate.getDate();
            },
            // 获取客户经理
            getCateManagerDetailRelationList() {
                this.showSpin = true;
                api.webGetCateManagerDetailRelationList({}).then(res => {
                    this.showSpin = false;
                    if (res.code === 0) {
                        this.subCateManagerList = res.data.managerList;
						console.log(this.subCateManagerList);
                    }
                });
            },
            onClickMainCate(mainCate) {
            	let mainCateName = this.memberInfoForm.selectMainCategoryStr;
            	let mainCategoryIds = this.memberInfoForm.selectMainCategoryIds;
            	let productionTypeArray = this.memberInfoForm.memberProductionTypeArray;
            	let cateIndex = mainCategoryIds.indexOf(mainCate.mainCategoryUuid);
            	if (cateIndex > -1) {
            		//前面已选择，再选择则取消
            		mainCateName = mainCateName.replace("[" + mainCate.mainCategoryName + "]", "")
            		this.memberInfoForm.selectMainCategoryIds.splice(cateIndex, 1);
            		let productionTypeIndex = productionTypeArray.indexOf(mainCate.mainCategoryName);
            		if (productionTypeIndex > -1) {
            			this.memberInfoForm.memberProductionTypeArray.splice(productionTypeIndex, 1);
            		}
            	} else {
            		//选择
            		if (mainCateName == '') {
            			mainCateName = '[' + mainCate.mainCategoryName + ']';
            			this.memberInfoForm.selectMainCategoryIds.push(mainCate.mainCategoryUuid);
            			this.memberInfoForm.memberProductionTypeArray.push(mainCate.mainCategoryName);
            		} else {
            			mainCateName += '[' + mainCate.mainCategoryName + ']';
            			this.memberInfoForm.selectMainCategoryIds.push(mainCate.mainCategoryUuid);
            			this.memberInfoForm.memberProductionTypeArray.push(mainCate.mainCategoryName);
            		}
            	}
            	this.memberInfoForm.selectMainCategoryStr = mainCateName;
            },
            getMemberDetailInfo() {
                let strUserUuid = this.$cookies.get('userUuid');
                if (strUserUuid) {
                    this.loginUuid = strUserUuid;
                    api.getMemberDetailInfo({
                        userUuid: strUserUuid
                    }).then(res => {
                        if (res.code === 0) {
                            this.memberInfoForm = res.data;
                            //倒计时
                            this.timeSecond = res.data.expiresTimeSecond;
                            //日期
                            let memberCreateTimeStr = res.data.memberCreateTime;
                            if (memberCreateTimeStr != null && memberCreateTimeStr != '' &&
                                memberCreateTimeStr !=
                                undefined) {
                                this.memberInfoForm.memberCreateTime = memberCreateTimeStr.substring(0, 10);
                            }
                            //生产种类
                            let mainCategoryStr = '';
                            this.memberInfoForm.memberProductionTypeArray = this.memberInfoForm.memberProductionType
                                .split('|');
                            let productionTypeArray = this.memberInfoForm.memberProductionTypeArray;
                            productionTypeArray.forEach(e => {
                                if (e != '' && e != null && e != undefined) {
                                    mainCategoryStr += '[' + e + ']';
                                }
                            });
                            this.memberInfoForm.selectMainCategoryStr = mainCategoryStr;
                            this.getAllRegionList();
                        }
                    });
                }
            }
        },
        components: {

        }
    };
</script>

<style scope>
    .modal-body {
        overflow: auto !important;
    }

    .productType .bv-no-focus-ring {
        display: flex;
    } 
    .reminder-footer {
        display: flex;
        justify-content: space-between;
    }

    /* new */
    /* body{width:100%;height:100%;background:url(../../assets/bg.png) no-repeat;background-size:cover;} */

    .wrapper {
        background: url(../../assets/bg.png);
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        min-width: 1000px;
        z-index: -10;
        zoom: 1;
        background-color: #fff;
        background-repeat: no-repeat;
        background-size: cover;
        -webkit-background-size: cover;
        -o-background-size: cover;
        background-position: center 0;
    }


    .register-content {
        width: 1170px;
        position: absolute !important;
        left: 50% !important;
        top: 50% !important;
        transform: translate(-50%, 50%) !important;
        -webkit-transform: translate(-50%, -50%) !important;
        max-height: 73%;
        overflow-y: auto; 
        overflow-x: hidden; 
    }

    .register-info {
        width: 1170px;
    }

    .register-wrap .card-body {
        padding: 0px;
        height: auto !important;
    }

    /* 标题 */
    .register-wrap .card-header {
        font-weight: bold;
        font-size: 21px;
        padding: 10px 0px;
        color: #333;
        text-align: center;
        background-color: #fff;
    }

    /* 表单 */
    .registerForm {
        padding: 20px 80px;
    }

    .registerForm .form-row {
        margin-right: 0px !important;
        margin-left: 0px !important;
        height: 31px;
        line-height: 31px;
    }

    .form-row>.col,
    .form-row> {
        padding-right: 0px !important;
        padding-left: 0px !important;
    }

    .registerForm .col-form-label-sm,
    .registerForm .form-control-sm {
        font-size: 15px;
    }

    /* 多选框颜色 */
    .custom-control-input:checked~.custom-control-label::before {
        border-color: #01b252;
        background-color: #01b252;
    }

    .registerForm .custom-control-inline {
        font-size: 15px;
    }

    .registerForm .custom-control-label::before {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 6px;
        left: -1.5rem;
    }

    .registerForm .custom-control-label::after {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 6px;
        left: -1.5rem;
    }

    /* 客户经理下拉选择 */
    .registerForm .ivu-select-single .ivu-select-selection {
        font-size: 15px;
        height: 35px;
        line-height: 35px;
    }

    .registerForm .ivu-select-input {
        font-size: 15px;
        height: 35px;
        line-height: 35px;
    }


    /* 验证码 */
    .btn-code {
        width: 140px;
        background-color: #01b252;
        border: none !important;
        font-size: 15px !important;
        height: 35px !important;
    }

    .code-input {
        width: 240px !important;
        height: 35px !important;
        line-height: 35px !important;
        padding-left: 10px !important;
    }

    .registerForm .btn-secondary {
        background-color: #00B151 !important;
    }

    .btn-secondary.focus,
    .btn-secondary:focus {
        background-color: #00B151 !important;
    }

    .btn-secondary.hover,
    .btn-secondary:hover {
        background-color: #00B151 !important;
    }

    /* 协议 */
    .statement {
        display: flex;
        align-items: center;
        align-content: center;
        justify-content: space-between;
        font-size: 14px;
        color: grey;
    }

    .statement .custom-control-label {
        font-size: 14px;
        line-height: 2.2;
    }

    .statement .custom-control-label a {
        color: #01b252;
    }

    .registerForm .statement .custom-control-label::before {
        position: absolute;
        top: 5px;
    }

    .registerForm .statement .custom-control-label::after {
        position: absolute;
        top: 5px;
    }

    /* 登录按钮 */
    .registerForm .d-flex {
        justify-content: flex-end;
    }

    .new-btn {
        border-radius: 6px;
        padding: 0px !important;
        border: none;
        height: 48px !important;
        line-height: 48px !important;
        font-size: 20px;
    }

    .register-btn {
        width: 100%;
        background-color: #01b252 !important;
        margin: 15px 0;
        border: none !important;
        font-size: 15px !important;

    }

    .login {
        text-align: right;
    }

    .login_a {
        color: #01b252;
        font-size: 16px;
    }

    .login a {
        color: #01b252;
        font-size: 16px;
    }

    .login a:hover {
        color: #01b252;
        margin-left: 0px;
        font-size: 16px;
        text-decoration: none;
    }



    /* 底部 */
    .home-footer {
        width: 1170px;
        position: absolute !important;
        left: 50% !important;
        bottom: 0% !important;
        transform: translate(-50%, 0%) !important;
        -webkit-transform: translate(-50%, 0%) !important;
    }

    .home-footer p {
        font-size: 14px;
        color: #8b8b8b;
        text-align: center;
    }

    .home-footer a {
        color: #8b8b8b;
    }

    .registerForm .text-lg-right {
        justify-content: flex-end !important;
    }

    /* .registerForm .col-form-label-sm{margin-right: 0px !important;} */
    .registerForm .col-lg-3,
    .registerForm .col {
        padding-left: 0px !important;
        padding-right: 0px !important;
    }

    .registerForm .col-lg-3 {
        flex: 0 0 15% !important;
        max-width: 15% !important;
    }

    /* 设置统一的高度和内边距 */
    .custom-input,
    .custom-select {
      height: 35px;  
      font-size: 14px;  
      line-height: 1.5;  
    }
        /* 自定义滚动条样式 */
    .register-content::-webkit-scrollbar {
        width: 4px;  
    }

    .register-content::-webkit-scrollbar-thumb {
        background-color: #01b252;
        border-radius: 10px;
    }

    .register-content::-webkit-scrollbar-thumb:hover {
        background-color: #019942; 
    }

    .register-content::-webkit-scrollbar-track {
        background-color: #f1f1f1; 
        border-radius: 10px;  
    }
</style>



// WEBPACK FOOTER //
// src/view/member/register.vue